export const picFilter = (value: string) => {
  if (value[0] === '/') {
    return value;
  }
  return `https://www.dentik.com/upload/${value}`;
};

export const dateFilter = (value: string) => {
  if (value) {
    return value.split(' ')[0];
  }
  return '';
};

export const substrFilter = (value: string, len: number = 100) => {
  value = value.replace(/<\/?[^>]*>/g, ''); // 去除HTML tag
  value = value.replace(/[ | ]*\n/g, '\n'); // 去除行尾空白
  value = value.replace(/&nbsp;/ig, ''); // 去掉&nbsp;

  if (value.length > len) {
    return `${value.substr(0, len)}...`;
  }
  return value;
};

export const coverSnToString = (value: number) => {
  if (value > 9) {
    return value.toString();
  }
  return `0${value}`;
};

export const productUrlFilter = (value: string) => {
  return `/#/productlist/${value}`;
};

export const newsUrlFilter = (value: string) => {
  return `/#/newslist/${value}`;
};
